<template>
	<div class="message_list">
    <ModalSetStore ref="modalSetStore" @action="setMainStore"></ModalSetStore>

		<v-col class="pt-5">
			<div>
				<v-row>
					<v-col cols="12" md="2" class="pr-md-0">
						<profile-menu></profile-menu>
					</v-col>

					<v-col cols="12" md="10" class="pl-md-5 py-0 mt-5 mt-md-0">
						<div class="d-block">
              <v-row align="stretch">
                <v-col cols="12" lg="4" v-if="buyerAllMessage.lists.length > 0">
                  <v-card outlined transparent elevation="0" class="review-list rounded-lg h-100" style="height: 100%;">
                    <v-card-title class="d-flex align-center justify-space-between">
                      Daftar Pesan
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            elevation="0"
                            color="success"
                            fab
                            dark
                            x-small
                            v-bind="attrs"
                            v-on="on"
                            @click="openModalSetStore()"
                          >
                            <v-icon>mdi-message-plus-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Buat Pesan Baru</span>
                      </v-tooltip>
                    </v-card-title>
                    <v-card-text class="d-flex flex-column align-center px-0" style="overflow-y: auto;">
                      <v-list three-line class="py-0">
                        <v-list-item-group
                          v-model="selectedItem"
                          color="primary"
                        >
                          <template v-for="(msg) in buyerAllMessage.lists">
                            <v-list-item
                              :key="msg.message_id"
                              class="px-4 border-bottom"
                              :class="(msg.message_read_datetime == '') ? 'unread' : 'read'"
                              @click="setActiveMessage(msg)"
                            >
                              <v-list-item-avatar>
                                <v-img style="background: #ddd;" :src="msg.store_image"></v-img>
                              </v-list-item-avatar>

                              <v-list-item-content>
                                <!-- <v-list-item-title class="font-size-14" v-html="msg.title"></v-list-item-title> -->
                                <v-list-item-subtitle><b :class="(msg.message_read_datetime == '') ? 'primary--text' : ''">{{ msg.store_name }}</b></v-list-item-subtitle>
                                <v-list-item-subtitle>
                                  <small class="d-block my-1" :class="(msg.message_read_datetime == '') ? 'black--text' : ''" style="line-height: 140%;" v-html="msg.message_content"></small>
                                </v-list-item-subtitle>
                                <small class="d-flex align-center justify-space-between grey--text mt-2">
                                  <span class="d-flex align-center flex-row">
                                    <v-icon dense small class="mr-1">mdi-clock-time-eight-outline</v-icon>
                                    {{ msg.message_send_datetime | tanggalCount }}
                                  </span>
                                  <template v-if="msg.message_status == 'Terkirim'"><v-icon small dense class="mr-1">mdi-check</v-icon></template>
                                  <template v-if="msg.message_status == 'Dibaca'"><v-icon small dense class="mr-1">mdi-check-all</v-icon></template>
                                </small>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                        </v-list-item-group>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-col>

                <v-col cols="12" :lg="(buyerAllMessage.lists.length > 0) ? '8' : '12'">
                  <v-card :loading="loadingMsg" outlined transparent elevation="0" class="review-list rounded-lg h-100 d-flex flex-column justify-space-between" style="height: 100%;">
                    <template v-if="selectedItemMsg">         
                      <template v-if="!loadingMsg">
                        <v-card-text class="d-flex flex-row align-start justify-space-between border-bottom">
                          <div class="d-flex flex-row align-center justify-start">
                            <v-avatar>
                              <img
                                :src="selectedItemMsg.store_image"
                                style="background: #ddd; width: 100%;"
                                :alt="selectedItemMsg.store_name"
                              >
                            </v-avatar>
                            <div class="d-flex flex-column ml-4">
                              <h4 class="primary--text">{{ selectedItemMsg.store_name }}</h4>
                              <small class="d-block text-muted" v-if="selectedItemMsg.message_send_datetime">pesan terakhir {{ selectedItemMsg.message_send_datetime | tanggalCount }}</small>
                              <small class="d-block text-muted" v-else>belum ada pesan sebelumya</small>
                            </div>
                          </div>

                          <v-btn
                            plain
                            raised
                            rounded
                            text
                            small
                            class="px-0"
                            title="Bersihkan percakapan"
                            @click="clearChat"
                          >
                            <v-icon small dense>mdi-window-close</v-icon>
                          </v-btn>
                        </v-card-text>

                        <v-card-text class="message-list-content" id="msg-content">
                          <v-row class="d-flex flex-column">
                            <template v-for="(chat, idx) in buyerMessage.lists">
                              <template v-if="chat.message_sender == 'store'">
                                <v-col cols="12" sm="9" class="text-left py-1" :key="idx">
                                  <v-card outlined elevation="0" class="review-list rounded-lg">
                                    <v-card-text class="d-flex flex-column">
                                      <div class="v-buyer mb-2">
                                        <div class="d-flex flex-row align-center">
                                          <div class="d-flex flex-column">
                                            <h6 class="d-flex align-center black--text">
                                              <template v-if="chat.message_status == 'Terkirim'"><v-icon small dense class="mr-1">mdi-check</v-icon></template>
                                              <template v-if="chat.message_status == 'Dibaca'"><v-icon small dense class="mr-1">mdi-check-all</v-icon></template>
                                              
                                              <span class="text-muted pr-2">Dikirim : </span>{{ chat.message_send_datetime | tanggalCount }}
                                            </h6>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="v-content font-size-12">
                                        {{ chat.message_content }}
                                      </div>
                                    </v-card-text>
                                  </v-card>
                                </v-col>
                              </template>

                              <template v-else>
                                <v-col cols="12" sm="9" align-self="end" class="text-right py-1" :key="idx">
                                  <v-card outlined elevation="0"  color="#eee" class="review-list rounded-lg">
                                    <v-card-text class="d-flex flex-column">
                                      <div class="v-buyer mb-2">
                                        <div class="d-flex flex-row align-center justify-end">
                                          <div class="d-flex flex-column justify-end text-right">
                                            <h6 class="d-flex align-center black--text">
                                              <template v-if="chat.message_status == 'Terkirim'"><v-icon small dense class="mr-1">mdi-check</v-icon></template>
                                              <template v-if="chat.message_status == 'Dibaca'"><v-icon small dense class="mr-1">mdi-check-all</v-icon></template>
                                              
                                              <span class="text-muted pr-2">Dikirim : </span>{{ chat.message_send_datetime | tanggalCount }}
                                            </h6>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="v-content font-size-12 text-right">
                                        {{ chat.message_content }}
                                      </div>
                                    </v-card-text>
                                  </v-card>
                                </v-col>
                              </template>
                            </template>

                          </v-row>
                        </v-card-text>

                        <v-card-text class="d-flex flex-column align-start border-top" style="width: 100%;">
                          <div class="d-block border rounded" style="width: 100%;">
                            <v-row class="align-center" dense style="width: 100%;">
                              <v-col cols="12" lg="10">
                                <v-textarea
                                  v-model="msgParams"
                                  auto-grow
                                  flat
                                  solo
                                  dense
                                  rows="2"
                                  hide-details="auto"
                                  class="single-textarea"
                                  style="width: 100%; font-size:14px; line-height: normal!important;"
                                ></v-textarea>
                              </v-col>
                              <v-col cols="12" lg="2">
                                <v-btn
                                  :loading="processLoading"
                                  class="white--text align-self-end"
                                  color="primary"
                                  depressed
                                  block
                                  :disabled="(msgParams == '') ? true : false "
                                  @click="sendMessages(selectedItemMsg.store_slug)"
                                >
                                  <v-icon dense>mdi-send</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </div>
                        </v-card-text>
                      </template>
                    </template>

                    <template v-else>
                      <v-card-text class="d-flex flex-column align-center justify-center" style="min-height: 500px;">
                        <template v-if="buyerAllMessage.lists.length > 0">
                          <v-img class="d-block mx-auto mb-5" width="90" max-width="90" max-height="90" contain :src="'/assets/seller/message.png'"></v-img>
                          <p class="text-muted text-center">Pilih pesan dari daftar untuk<br>memulai percakapan dengan user tersebut.</p>
                        </template>
                        <template v-else>
                          <template v-if="!store_slug || !store_slug !== ''">
                            <v-row class="d-flex align-center text-center justify-center">
                              <v-col cols="12" class="">
                                <v-img class="d-block mx-auto mb-5" width="90" max-width="90" max-height="90" contain :src="'/assets/seller/message.png'"></v-img>
                                <p class="d-block text-muted text-center mb-5">Belum ada riwayat percakapan sebelumnya,<br>pilih toko untuk memulai percakapan baru dengan toko pilihan Anda.</p>
                                <v-btn depressed height="60" color="primary" class="rounded-lg py-0" @click="openModalSetStore()">
                                  <div class="text-caption font-weight-bold">Pilih Toko</div>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </template>
                        </template>
                      </v-card-text>
                    </template>
                  </v-card>
                </v-col>
              </v-row>

              <v-pagination v-if="buyerAllMessage.pagination.total_page > 1 && buyerAllMessage.lists.length > 0" @input="updatePage" v-model="page" :length="buyerAllMessage.pagination.total_page" total-visible="7" circle class="d-flex justify-end no-button-focus py-2"></v-pagination>
            </div>
					</v-col>
				</v-row>
			</div>
		</v-col>
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import ProfileMenu from '@/components/layout/store/ProfileMenu';
import ModalSetStore from './ModalSetStore.vue'

export default {
  components: {
    ProfileMenu,
    ModalSetStore
  },

  data() {
    return {
      loading: false,
      loadingMsg: false,
      processLoading: false,
      store_slug: null,
      detailStore: null,
      page: 1,
      limit: 8,
      params: [],
      sort: {},
      sortBy: '',
      sortDir: '',

      selectedItem: null,
      selectedItemMsg: null,
      msgParams: '',
      isMobile: false,
    }
  },

  props:{
    type: String
  },

  computed: {
    ...mapState('messages', ['buyerAllMessage', 'buyerMessage']),
  },

  methods: {
    ...mapActions('messages', ['getAllMessageBuyer', 'getMessageBuyer',  'sendMessage']),
    ...mapMutations(['makeAlert']),

    openModalSetStore(){
			this.$refs.modalSetStore.modalShow();
		},

    async getStoreDetail() {
			await this.$http
				.get(`/store/detail-store/${this.store_slug}`)
				.then((res) => {
					const data = res.data.data
					this.detailStore = data
          this.selectedItemMsg = {
            message_buyer_id: null,
            message_content: '',
            message_delete_datetime: null,
            message_id: null,
            message_read_datetime: null,
            message_send_datetime: null,
            message_sender:  null,
            message_status: null,
            message_store_id: data.store_id,
            store_image: data.store_image,
            store_name: data.store_name,
            store_slug: data.store_slug
          }
				})
				.catch(() => {
				})
		},

    scrolledContent() {
      setTimeout(() => {
        var messageThread = document.getElementById('msg-content');
        messageThread.scrollTop = messageThread.scrollHeight;
      }, 1060);
    },

    async getAllMessages() {
      this.loading = await true

      await this.getAllMessageBuyer().then(() => {
        setTimeout(() => {
          this.loading = false
        }, 1000);
      }).catch(() => {
        this.loading = false
      })
      
    },

    async openMessageSeller(store_slug) {
      this.loadingMsg = await true
      
      if (store_slug) {
        const params = await {
          message_store_slug: store_slug
        }

        this.getMessageBuyer(params)
          .then(() => {
            this.getAllMessages()
            setTimeout(() => {
              this.loadingMsg = false
            }, 1000);
            this.scrolledContent()
          })
          .catch(() => {
            this.loadingMsg = false
          })  
      } else {
        this.loadingMsg = false
      }
    },

    async updateMessageBuyer(store_slug) {
      if (store_slug) {
        const params = await {
          message_store_slug: store_slug
        }

        this.getMessageBuyer(params)
          .then(() => {
            this.getAllMessages()
            this.scrolledContent()
          })
          .catch(() => {
            this.loadingMsg = false
          })  
      } else {
        this.loadingMsg = false
      }
    },

    async setActiveMessage(msg) {
      this.selectedItemMsg = await msg
      this.openMessageSeller(msg.store_slug)
    },

    clearChat() {
      this.selectedItemMsg = null
      this.selectedItem = null
      this.msgParams = ''
      this.getAllMessages()
    },

    sendMessages(store_slug) {
      let slugs = (store_slug) ? store_slug : this.store_slug
      this.processLoading = true
      const params = {
        store_slug: slugs,
        payload: {
          message_content: this.msgParams
        }
      }

      this.sendMessage(params)
        .then((response) => {
          this.makeAlert({ code: 'success', type: 'success', message: response.message, show: true })
          this.getAllMessages()
          this.updateMessageBuyer(slugs)
          this.msgParams = ''
          this.processLoading = false
        }).catch(() => {
          this.processLoading = false
        })
    },

    setMainStore() {},
    
    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    },
  },
  async created() {
    this.loading = await true
    this.store_slug = await (this.$route.query.chat !== undefined) ? this.$route.query.chat : localStorage.getItem('HwiEcomStore')
    await this.$store.dispatch('setPageTitle', 'Inbox');
    this.getStoreDetail()
    this.getAllMessages()
    this.openMessageSeller(this.store_slug)
  }
}
</script>